import { Popover, Stack, Typography } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import { DroneBox } from "../../DroneBox";
import { DeleteIcon, EditIcon } from "../../../../../Reuse/Icon";
import CampusTitle from "../../CampusTitle";
import CustomIconButton from "../../../../../Reuse/UI/CustomIconButton";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import StyledButton from "../../../../../Reuse/UI/StyledButton";
import { CheckValue } from "../../../../../Service/service";
import { useNavigate } from "react-router";
import StyleStack from "../../../../../Reuse/UI/StyleStack";
import { DoorDetail, DroneDetail } from "./DroneDetail";
import FloorView from "../FloorView";
import { useActiveCampusContext, useActiveFloorContext } from "../Constant";
import { useDebouncedApiCall, useEffectAfterMount } from "../../../../../hooks";
import { useAlerts } from "../../../../../context";
import { deleteCampusById } from "../../../../../Service/Api/campus";

import { useCampusViewState } from "./hooks/useCampusViewState";
import { useMapActions } from "./hooks/useMapActions";
import { useDroneUIState } from "./hooks/useDroneUIState";
import useDronesList from "../DroneNest/hooks/useDronesList";
import useDoorsList from "../DroneNest/hooks/useDoorsList";

const ViewCampus = () => {
  const navigate = useNavigate();
  const { setActiveFloor, setAction } = useActiveFloorContext();
  const { activeCampus } = useActiveCampusContext();

  const { show, setShow, droneNest, setDroneNest, toggleView } =
    useCampusViewState(setAction);

  const { availableDronesList } = useDronesList();

  const { availableDoorsList } = useDoorsList();

  const unAssignDoorsList = useMemo(() => {
    return !!availableDoorsList ? Object.values(availableDoorsList) : [];
  }, [availableDoorsList]);

  const unAssignDronesList = useMemo(() => {
    return !!availableDronesList ? Object.values(availableDronesList) : [];
  }, [availableDronesList]);

  const { showOnMap } = useMapActions({
    setActiveFloor,
    setAction,
    droneNest,
  });

  const editHandler = useCallback(
    (e) => {
      e.preventDefault();
      navigate("edit");
    },
    [navigate],
  );

  const droneNestClicked = useCallback(
    (drone_nest) => {
      if (drone_nest?.id) {
        setDroneNest(drone_nest.id);
        setShow("drone_nest");
      }
    },
    [setDroneNest, setShow],
  );

  /* Effects (kept SAME logic) */
  useEffectAfterMount(() => {
    if (show !== "drone_nest") {
      setDroneNest(null);
      setAction((prev) => ({ ...prev, showOnMap: null }));
    }
    toggleView("view", show);
  }, [show,droneNest]);

  return (
    <React.Fragment>
      <Stack direction={"row"} gap={2} sx={{ width: "100%" }}>
        <Stack
          direction={"row"}
          gap={1}
          alignItems={"center"}
          sx={{ flexGrow: 1, width: 0 }}
        >
          <CampusTitle
            name={activeCampus?.name}
            index={activeCampus?.campus_number}
            variant={"h1"}
            // sx={{ width: 0, flexGrow: 1 }}
          />
          <DroneBox
            availableDoors={activeCampus?.availableDoors}
            available_doors={activeCampus?.available_doors}
            availableDrone={activeCampus?.availableDrone}
            unavailableDrone={activeCampus?.unavailableDrone}
            unAssignDoorsList={unAssignDoorsList}
            unAssignDronesList={unAssignDronesList}
            clickBox={setShow}
            boxValue={show}
            showAvailableEmpty={true}
            showUnavailableEmpty={true}
            showDoorsEmpty={true}
            showUnAssignedDoorsEmpty={true}
            showUnAssignedDronesEmpty={true}
          />
        </Stack>
        <Stack direction={"row"} gap={1} sx={{ flexGrow: 0 }}>
          <StyledButton
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={editHandler}
          >
            Edit Campus
          </StyledButton>
          <MoreUI />
        </Stack>
      </Stack>
      <Stack
        direction={"row"}
        gap={1}
        sx={{ flexGrow: 1, height: "calc(100% - 76px)" }}
      >
        <FloorView showFooter={false} droneNestClicked={droneNestClicked} />
        {CheckValue(show) ? (
          <DroneUI
            title={show}
            showOnMap={showOnMap}
            droneNest={droneNest}
            drone_nests={activeCampus.drone_nests}
            availableDoors={activeCampus.availableDoors}
            availableDrone={activeCampus.availableDrone}
            unavailableDrone={activeCampus.unavailableDrone}
            unAssignDoorsList={unAssignDoorsList}
            unAssignDronesList={unAssignDronesList}
            setShow={setShow}
          />
        ) : null}
      </Stack>
    </React.Fragment>
  );
};

export default ViewCampus;

const DroneUI = React.memo((props) => {
  const {
    title = "",
    availableDrone = [],
    unavailableDrone = [],
    availableDoors = [],
    unAssignDoorsList = [],
    unAssignDronesList = [],
    droneNest,
    drone_nests,
    setShow,
    ...rest
  } = props;

  const {
    titleUI,
    isData,
    droneBoxProps,
    availabelDronesArr,
    unavailabelDronesArr,
    availableDoorsArr,
    unAssignDoorsArr,
    unAssignDronesArr,
  } = useDroneUIState({
    title,
    availableDrone,
    unavailableDrone,
    availableDoors,
    droneNest,
    drone_nests,
    unAssignDoorsList,
    unAssignDronesList,
  });

  return (
    <StyleStack
      direction={"column"}
      gap={1.5}
      sx={{ maxWidth: 600, width: "50%", paddingY: 1.5, paddingX: 2 }}
      //   sx={{ width: "40.66%", paddingY: 1.5, paddingX: 2 }}
    >
      <Stack
        direction={"row"}
        gap={1}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ width: "100%" }}
      >
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <CampusTitle name={titleUI} />
          <DroneBox
            availableDrone={availabelDronesArr}
            unavailableDrone={unavailabelDronesArr}
            availableDoors={availableDoorsArr}
            unAssignDoorsList={unAssignDoorsArr}
            unAssignDronesList={unAssignDronesArr}
            {...droneBoxProps}
          />
        </Stack>
        <StyledButton variant="outlined" onClick={() => setShow(null)}>
          Close
        </StyledButton>
      </Stack>
      <Stack
        direction={"column"}
        gap={1.5}
        flexGrow={1}
        alignItems={"center"}
        justifyContent={"center"}
        sx={{ width: "100%", overflow: "hidden" }}
      >
        {isData ? (
          <Stack
            direction={"column"}
            gap={1.5}
            flexGrow={1}
            sx={{ width: "100%", overflowY: "scroll" }}
          >
            {availableDoorsArr.map((dronenest) => (
              <DoorDetail
                key={dronenest?.door?.id}
                drone_nest={dronenest}
                {...rest}
              />
            ))}
            {unAssignDoorsArr.map((door) => (
              <DoorDetail
                key={door?.id}
                drone_nest={{ doors: door }}
                {...rest}
                showOnMap={null}
                isShowDroneNest={false}
              />
            ))}
            {availabelDronesArr.map((drone) => (
              <DroneDetail
                key={drone.id}
                divStatus={"available"}
                {...rest}
                {...drone}
              />
            ))}
            {unavailabelDronesArr.map((drone) => (
              <DroneDetail
                key={drone.id}
                divStatus={"unavailable"}
                {...rest}
                {...drone}
              />
            ))}
            {unAssignDronesArr.map((drone) => (
              <DroneDetail
                key={drone.id}
                divStatus={"unavailable"}
                // {...rest}
                {...drone}
                showOnMap={null}
                isShowDroneNest={false}
              />
            ))}
          </Stack>
        ) : (
          <Typography variant="h5" sx={{ color: "#a7a7a7" }}>
            No Data Available
          </Typography>
        )}
      </Stack>
    </StyleStack>
  );
});

const MoreUI = React.memo(() => {
  const { activeCampus } = useActiveCampusContext();
  const { showAlerts } = useAlerts();
  const navigate = useNavigate();
  const { call } = useDebouncedApiCall();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const deleteDialogHandler = useCallback(
    async (e) => {
      e.preventDefault();
      if (!!activeCampus?.id) {
        try {
          const res = await call(() => deleteCampusById(activeCampus?.id));
          showAlerts("Campus deleted successfully.", "error");
          navigate("..");
        } catch (error) {}
      }

      handleClose();
    },
    [navigate, activeCampus?.id, showAlerts, call],
  );

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <CustomIconButton onClick={handleClick} aria-describedby={id}>
        <MoreHorizRoundedIcon />
      </CustomIconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            width: 188,
            border: "1px solid #101828",
            borderRadius: 1.5,
            padding: 1,
            background: "#FFFFFF",
            mt: 1,
          },
        }}
      >
        <Stack direction="column" gap={1.5}>
          <StyledButton
            variant="text"
            startIcon={<DeleteIcon />}
            onClick={deleteDialogHandler}
            sx={{
              color: "#BC1B06",
              justifyContent: "flex-start",
              fontSize: 18,
              [`&:hover`]: {
                color: "#BC1B06",
              },
            }}
          >
            <Typography variant="subtitle1">{"Delete Campus"}</Typography>
          </StyledButton>
        </Stack>
      </Popover>
    </>
  );
});
